<script>
export default {
    name: 'IconMoreVertical'
}
</script>
<template>
    <svg
        class="base-icon icon-more-vertical"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 44a4 4 0 110 8 4 4 0 010-8zm0-16a4 4 0 110 8 4 4 0 010-8zm0-16a4 4 0 110 8 4 4 0 010-8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
